module.exports = __webpack_public_path__ + "img/brands8-1.2ce18e10.png";